import { Plan } from "../redux/slices/plans";
import { SurveyAnswersState } from "../redux/slices/surveyAnswers";
import { UserDataState } from "../redux/slices/userData";
import JumbleberryHandlers from "./publishers/jumbleberry";
import TestPixelHandlers from "./publishers/testPixel";
import AdsWizzHandlers from "./publishers/adswizz";
import PodsightsHandlers from "./publishers/podsights";
import SnapchatHandlers from "./publishers/snapchat";
import LiveIntentHandlers from "./publishers/liveIntent";
import ImpactHandlers from "./publishers/impact";
import GoogleAdwordsHandlers from "./publishers/adwords";
import ArtsaiHandlers from "./publishers/artsai";
import BingHandlers from "./publishers/bing";
import PinterestHandlers from "./publishers/pinterest";
import HealthlineHandlers from "./publishers/healthline";
import UKTVHandlers from "./publishers/uktv";
import FacebookCapiHandlers from "./publishers/facebookCapi";

import {
  fireCallbackWithRetry,
  PIXEL_RETRY_DELAY_MS,
  PIXEL_RETRY_MAX_ATTEMPTS,
} from "./utils";

export interface HandlerCallbackArgs {
  plan?: Plan;
  surveyAnswers?: SurveyAnswersState;
  email?: string;
  name?: string;
  order?: JsonObject;
  isSoldOut?: boolean;
  userData?: UserDataState;
  fbCapiParams?: JsonObject;
}

export type HandlerCallback = (args: HandlerCallbackArgs) => void;

export interface HandlerOptions {
  retry?: boolean;
}

const events = {
  init: [] as HandlerCallback[],
  lead: [] as HandlerCallback[],
  initiateCheckout: [] as HandlerCallback[],
  purchase: [] as HandlerCallback[],
  viewContent: [] as HandlerCallback[],
  HMLead: [] as HandlerCallback[],
  HMInitiateCheckout: [] as HandlerCallback[],
  HMPurchase: [] as HandlerCallback[],
  HMLandingPageView: [] as HandlerCallback[],
};

export type EVENTS = keyof typeof events;

/**
 * Fire a conversion pixel event and pass in necessary props.
 * */
export function firePixelEvent(
  event: EVENTS,
  props: HandlerCallbackArgs = {}
): void {
  const handlers = events[event];
  handlers.forEach((handler) => {
    handler(props);
  });
}

/**
 * Register a conversion pixel event handler.
 * */
export function registerHandler(
  event: EVENTS,
  callback: HandlerCallback,
  options: HandlerOptions = {}
) {
  // Retry is on by default. Need to explicitly pass in false to turn off.
  const maxAttempts = options?.retry === false ? 1 : PIXEL_RETRY_MAX_ATTEMPTS;
  function wrappedCallback(args: HandlerCallbackArgs): void {
    fireCallbackWithRetry(callback, args, PIXEL_RETRY_DELAY_MS, maxAttempts);
  }
  events[event].push(wrappedCallback);
}

export default function initializeHandlers() {
  PinterestHandlers();
  GoogleAdwordsHandlers();
  BingHandlers();
  SnapchatHandlers();
  UKTVHandlers();
  ArtsaiHandlers();
  ImpactHandlers();
  LiveIntentHandlers();
  HealthlineHandlers();
  JumbleberryHandlers();
  PodsightsHandlers();
  AdsWizzHandlers();
  TestPixelHandlers();
  FacebookCapiHandlers();
}
